import { useMutation } from '@tanstack/react-query'
import { NoContent } from '@/common/types_and_interfaces.ts'
import { ApiCallResult } from '@/lib/tanstack-utils.types.ts'
import axios from 'axios'
import { parseRequestError } from '@/common/utilities.ts'

export type GradeAwardPayload = {
  id: number
  amount: number
}[]

export type UpdateAwardParams = {
  programId: number
  purseId: number
}

const updateGradeAwardBrackets = async (
  params: UpdateAwardParams,
  payload: GradeAwardPayload
): Promise<NoContent> => {
  const { programId, purseId } = params

  try {
    await axios.post(
      `/programs/${programId}/purses/${purseId}/settings/grade_distributions`,
      { grade_awards: payload }
    )
    return null
  } catch (e) {
    throw parseRequestError(e)
  }
}

type RequestPayload = {
  params: UpdateAwardParams
  payload: GradeAwardPayload
}
export const useUpdateGradeDistributions = (): ApiCallResult<
  NoContent,
  RequestPayload
> => {
  return useMutation({
    mutationFn: async ({ params, payload }: RequestPayload) => {
      return await updateGradeAwardBrackets(params, payload)
    },
  })
}
